import { render, staticRenderFns } from "./CustomBtn.vue?vue&type=template&id=1e911126&scoped=true"
import script from "./CustomBtn.vue?vue&type=script&lang=js"
export * from "./CustomBtn.vue?vue&type=script&lang=js"
import style0 from "./CustomBtn.vue?vue&type=style&index=0&id=1e911126&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e911126",
  null
  
)

export default component.exports